import {
  PHOTO_ITEM_TYPE,
  TRANSACTION_ITEM_TYPE,
} from '../../../../../../constants/transactions';

/**
 * Maps a PurchasedCustomPrint's configuration into a configuration
 * that is expected by the Configurator.
 *
 * @param {Object} [purchasedCustomPrint] The PurchasedCustomPrint.
 * @returns {{}|{custom_print_caption, photos}}
 */
export const mapPurchasedCustomPrintToConfiguration = purchasedCustomPrint => {
  if (!purchasedCustomPrint) {
    return {};
  }

  return {
    custom_print_caption: purchasedCustomPrint.custom_print_caption,
    photos: purchasedCustomPrint.photos.records,
  };
};

/**
 * Finds the relevant transactionItem for a purchasedCustomPrint
 *
 * @param {Object} [purchasedCustomPrint] The PurchasedCustomPrint.
 * @returns {object}
 */
export const getPurchasedCustomPrintTransactionItem = purchasedCustomPrint => {
  if (!purchasedCustomPrint || !purchasedCustomPrint?.transaction) {
    return null;
  }

  const { transaction, custom_print: customPrint } = purchasedCustomPrint;

  return (transaction?.transaction_items?.records ?? []).find(txItem => {
    if (txItem.item_type === TRANSACTION_ITEM_TYPE.CUSTOM_PRINT) {
      return txItem.purchased_custom_print?.id === purchasedCustomPrint.id;
    }

    // We do not need to check anything else if the purchased custom print has no custom print tied.
    // We will find nothing here.
    if (!customPrint) {
      return false;
    }

    if (
      txItem.item_type === TRANSACTION_ITEM_TYPE.PHOTO &&
      txItem.photo_item_type === PHOTO_ITEM_TYPE.PRINT_PACKAGE
    ) {
      return !!txItem.print_package.items.records.find(
        item => item.custom_print?.id === customPrint.id,
      );
    }

    return false;
  });
};
